import {
  Box,
  Button,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
// import AddIcon from '@material-ui/icons/Add';
import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@material-ui/icons/Remove';
import RemoveIcon from '@mui/icons-material/Remove';
import {
  ACTION_LEFT_DRAWER,
  ACTION_OPEN_TOOLBAR,
  ACTION_RESET,
  ACTION_RIGHT_DRAWER,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
} from '../../component/MainUIFrame/constants';
import { useMainFrameDispatch } from '../../component/MainUIFrame/MainFrame';
import EHRToolbar from '../ehr/contents/toolbarContent';
import { useEffect } from 'react';
import { ehrAPIBaseService, ehrAPIService } from '../../http-common';
import { setProgress } from '../../redux/features/progressSlice';
import { setSnackbarState } from '../../redux/features/snackbarSlice';
import { useDispatch, useSelector } from 'react-redux';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { generateNotifications } from '../../component/reusableLogic';
import { useSnackbar } from 'notistack';
import PatientSearchPage from '../../component/FhirComponents/template/Claims/patientSearchPage';
import axios from 'axios';
import _ from 'lodash';

const tableStyle = {
  border: '1px solid black',
  borderCollapse: 'collapse',
  textAlign: 'center',
  width: '100%',
};

const tdStyle = {
  border: '1px solid #85C1E9',
  background: 'white',
  padding: '5px',
};

const thStyleActions = {
  border: '1px solid #3498DB',
  background: '#3498DB',
  color: 'white',
  padding: '5px',
  width: '10%',
};

const thStyleStatus = {
  border: '1px solid #3498DB',
  background: '#3498DB',
  color: 'white',
  padding: '5px',
  width: '20%',
};

const thStyleNote = {
  border: '1px solid #3498DB',
  background: '#3498DB',
  color: 'white',
  padding: '5px',
  width: '30%',
};

const thStylequantity = {
  border: '1px solid #3498DB',
  background: '#3498DB',
  color: 'white',
  padding: '5px',
  width: '20%',
};

const thStyleprice = {
  border: '1px solid #3498DB',
  background: '#3498DB',
  color: 'white',
  padding: '5px',
  width: '20%',
};

const thStyle1 = {
  border: '1px solid #3498DB',
  background: '#3498DB',
  color: 'white',
  padding: '5px',
  width: '30px',
};

const chargeItemStatusInfo = [
  {
    display: 'planned',
  },
  {
    display: 'billable',
  },
  {
    display: 'not-billable',
  },
  {
    display: 'aborted',
  },
  {
    display: 'billed',
  },
  {
    display: 'entered-in-error',
  },
  {
    display: 'unknown',
  },
];

const invoiceStatus = [
  {
    display: 'draft',
  },
  {
    display: 'issued',
  },
  {
    display: 'balanced',
  },
  {
    display: 'cancelled',
  },
  {
    display: 'entered-in-error',
  },
];

const InvoicePage = ({
  setListView,
  isEdit,
  invoiceObject,
  setSelectionModel,
}) => {
  let selectedPatientId = 0;
  if (invoiceObject.patient !== undefined) {
    selectedPatientId = invoiceObject.patient.split('/')[1];
    console.log('selected patient id ', selectedPatientId);
  }
  const [selectedPatient, setSelectedPatient] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  useEffect(() => {
    console.log('selectedPatient', selectedPatient);
  }, [selectedPatient]);

  const dispatch = useMainFrameDispatch();
  const reduxDispatch = useDispatch();
  const [initialChargeItems, setInitialchargeitems] = useState([
    {
      status: '',
      code: '',
      display: '',
      quantity: '',
      totalPriceComponent: '',
      note: '',
    },
  ]);

  const [invoiceInitialState, setInvoiceinitialState] = useState({
    status: '',
    date: '',
    subject: '',
    totalPriceComponent: 0,
  });

  const [chargeItemInputFields, setChargeItemInputFields] = useState([
    {
      status: '',
      note: '',
      quantity: '',
      priceOverride: '',
      code: '',
      display: '',
    },
  ]);

  const [chargeItemIds, setChargeItemIds] = useState([]);
  const [chargeItems, setChargeItems] = useState([]);
  const lineItems = [];

  const handleAddFields = () => {
    console.log('Handle add fields');
    let newfield = {
      status: '',
      note: '',
      quantity: '',
      priceOverride: '',
      code: '',
      display: '',
    };
    setChargeItemInputFields([...chargeItemInputFields, newfield]);
    lineItems.push(newfield);
  };

  const getChargeItems = async () => {
    try {
      const chargeItemResponse = await ehrAPIBaseService.get(
        `fhir/search/?resourceType=ChargeItem&subject=` + selectedPatientId
      );
      console.log('response of chargeItem ', chargeItemResponse);
      let tempRows = [];
      for (const item of chargeItemResponse?.data?.entry) {
        let singleRow = {};
        singleRow.id = _.get(item, 'resource.id', '');
        singleRow.price = _.get(item, 'resource.priceOverride.value', '');
        singleRow.quantity = _.get(item, 'resource.quantity.value', '');
        singleRow.status = _.get(item, 'resource.status', '');
        singleRow.note = _.get(item, 'resource.note[0].text');
        tempRows.push(singleRow);
      }
      console.log('temp rows :', tempRows);
      setChargeItems(tempRows);
      console.log('items of charge ', chargeItems);
    } catch (e) {
      console.error(`EHR->ehrGetAllchargeitems ${e}`);
    }
  };

  useEffect(() => {
    getChargeItems();
  }, []);

  useEffect(() => {
    console.log('line items are ', lineItems);
    console.log('charge item ', chargeItemInputFields);
  }, [lineItems, chargeItemInputFields]);

  const handleRemoveFields = index => {
    console.log('remove fileds');
    let data = [...chargeItemInputFields];
    let total = invoiceInitialState?.totalPriceComponent;
    console.log('total price component ', total);
    total = total - parseInt(data[index].priceOverride);
    setInvoiceinitialState({
      ...invoiceInitialState,
      totalPriceComponent: total,
    });
    data.splice(index, 1);
    setChargeItemInputFields(data);
  };

  const handleChangeInput = (index, event) => {
    console.log('handle charge input..', event.current);
    const { name, value } = event.target;
    const statusValue = event.target.dataset.value;
    const list = [...chargeItemInputFields];
    if (name !== undefined) {
      list[index][name] = value;
    } else {
      list[index]['status'] = statusValue;
    }
    setChargeItemInputFields(list);
    let total = 0;
    for (let i = 0; i < list.length; i++) {
      console.log('price override ', list[i].priceOverride);
      if (isNaN(parseInt(list[i].priceOverride))) {
        total = 0;
      } else {
        total = total + parseInt(list[i].priceOverride);
      }
    }
    console.log('totalPriceComponent', total);
    setInvoiceinitialState({
      ...invoiceInitialState,
      totalPriceComponent: total,
    });
  };

  const createInvoice = async () => {
    console.log('creating invoice ...');
    console.log('length of the line items ', chargeItemInputFields.length);
    let totalPrice = 0;
    for (let i = 0; i < chargeItemInputFields.length; i++) {
      const chargeItem = {
        code: {
          coding: [
            {
              code: '01510',
              display:
                'Additional flat rate for observation after diagnostic coronary angiography',
            },
          ],
        },
        note: [
          {
            text: chargeItemInputFields[i].note,
          },
        ],
        priceOverride: {
          currency: 'USD',
          value: parseInt(chargeItemInputFields[i].priceOverride),
        },
        quantity: {
          value: parseInt(chargeItemInputFields[i].quantity),
        },
        resourceType: 'ChargeItem',
        status: chargeItemInputFields[i].status,
        subject: {
          reference: 'Patient/' + selectedPatient?.id,
        },
      };
      console.log('charge item req ', chargeItem);
      let type = '';
      let message = '';
      let description = '';
      try {
        const response = await ehrAPIService.post(`createResource`, chargeItem);
        console.log('charge item response ', response);
        chargeItemIds.push(response?.data?.id);
      } catch (e) {
        console.log('exception ', e);
      }
    }
    console.log("charge item id's ", chargeItemIds);
    const invoiceRequest = {
      resourceType: 'Invoice',
      status: invoiceInitialState?.status,
      date: invoiceInitialState?.date,
      subject: {
        reference: 'Patient/' + selectedPatient?.id,
      },
      lineItem: [
        {
          chargeItemReference: {
            reference: 'ChargeItem/eaa696c7-b95b-4bc3-a175-e8db0e981207',
            type: 'ChargeItem',
          },
        },
      ],
      totalNet: {
        currency: 'DOLLAR',
        value: invoiceInitialState?.totalPriceComponent,
      },
      totalPriceComponent: [
        {
          type: 'base',
          amount: {
            currency: 'DOLLAR',
            value: invoiceInitialState?.totalPriceComponent,
          },
        },
      ],
    };
    var lineItemColle = [];
    var lineItemColleNew = [];
    for (let i = 0; i < chargeItemIds.length; i++) {
      var singleRow = {};
      singleRow.chargeItemReference = {
        reference: 'ChargeItem/' + chargeItemIds[i],
        type: 'ChargeItem',
      };
      lineItemColle.push(singleRow);
    }
    invoiceRequest.lineItem = lineItemColle;

    console.log('Invoice request body', invoiceRequest);

    let type = '';
    let message = '';
    let description = '';
    try {
      const response = await ehrAPIService.post(
        `createResource`,
        invoiceRequest
      );
      console.log('invoice response ', response);
      type = 'success';
      message = 'Invoice Created Successfully';
      description = `Invoice Created Successfully`;
      setListView(true);
    } catch (e) {
      console.log('exception ', e);
      type = 'error';
      message = 'Invoice Creation Failed';
      description = `Something went wrong while creating Invoice,Please try again. `;
    } finally {
      reduxDispatch(setProgress(false));
      generateNotifications({
        title: message,
        descriptions: description,
        enqueueSnackbar,
        closeSnackbar,
        reduxDispatch,
      });
    }
  };

  const backToGridPage = () => {
    setListView(true);
    setSelectionModel('');
  };

  return (
    <Grid style={{ margin: '35px' }} className="overflow">
      {isEdit ? (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Invoice Status</InputLabel>
              <Select
                size="small"
                name="status"
                label="Invoice Status"
                value={invoiceObject?.status}
              >
                {invoiceStatus.map(v => (
                  <MenuItem
                    value={v.display}
                    onClick={e => {
                      var valueRead = e.target.dataset.value;
                      var seleOption = e.target.innerText;
                      setInvoiceinitialState({
                        ...invoiceInitialState,
                        status: e.target.dataset.value,
                      });
                    }}
                  >
                    {v.display}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                disableFuture={true}
                size="small"
                fullWidth
                label="Invoice Date"
                inputFormat="MM/dd/yyyy"
                value={invoiceObject?.invoiceCreatedDate}
                onChange={value => {
                  console.log(moment(value).format('yyyy-MM-DD'));
                  setInvoiceinitialState({
                    ...invoiceInitialState,
                    date: moment(value).format('yyyy-MM-DD'),
                  });
                }}
                renderInput={props => (
                  <TextField size="small" {...props} readOnly={true} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <table style={tableStyle}>
              <tbody>
                <tr>
                  <th style={thStyle1}>Items</th>
                  <th style={thStyleStatus}>Status</th>
                  <th style={thStyleNote}>Description</th>
                  <th style={thStylequantity}>Quantity</th>
                  <th style={thStyleprice}>Price</th>
                </tr>
                {chargeItems.map((item, index) => {
                  return (
                    <tr key={item.status}>
                      <td style={tdStyle}>{index + 1}</td>
                      <td style={tdStyle}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Charge item status</InputLabel>
                          <Select
                            size="small"
                            name="status"
                            value={item.status}
                            label={'Charge item status'}
                          >
                            {chargeItemStatusInfo.map(v => (
                              <MenuItem
                                value={v.display}
                                onClick={event =>
                                  handleChangeInput(index, event)
                                }
                              >
                                {v.display}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td style={tdStyle}>
                        <TextField
                          size="small"
                          fullWidth
                          label="note"
                          name="note"
                          value={item.note}
                          onChange={event => handleChangeInput(index, event)}
                        />
                      </td>
                      <td style={tdStyle}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Quantity"
                          name="quantity"
                          value={item.quantity}
                          onChange={event => handleChangeInput(index, event)}
                        />
                      </td>
                      <td style={tdStyle}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Price"
                          name="priceOverride"
                          value={item.price}
                          onChange={event => handleChangeInput(index, event)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={1}>
            <Typography>Sub total: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>${invoiceObject.totalPriceComponent}</Typography>
          </Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={1}>
            <Typography>Tax: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>0.00%</Typography>
          </Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={1}>
            <Typography>Total: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>${invoiceObject.totalPriceComponent}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              fullWidth
              onClick={backToGridPage}
              style={{ marginLeft: '50%' }}
            >
              Back
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PatientSearchPage
              fromInvoice
              setSelectedPatient={setSelectedPatient}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Invoice Status</InputLabel>
              <Select
                size="small"
                name="status"
                label="Invoice Status"
                value={invoiceInitialState?.status}
              >
                {invoiceStatus.map(v => (
                  <MenuItem
                    value={v.display}
                    onClick={e => {
                      var valueRead = e.target.dataset.value;
                      var seleOption = e.target.innerText;
                      setInvoiceinitialState({
                        ...invoiceInitialState,
                        status: e.target.dataset.value,
                      });
                    }}
                  >
                    {v.display}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                disableFuture={true}
                size="small"
                fullWidth
                label="Invoice Date"
                inputFormat="MM/dd/yyyy"
                value={invoiceInitialState?.date}
                onChange={value => {
                  console.log(moment(value).format('yyyy-MM-DD'));
                  setInvoiceinitialState({
                    ...invoiceInitialState,
                    date: moment(value).format('yyyy-MM-DD'),
                  });
                }}
                renderInput={props => (
                  <TextField size="small" {...props} readOnly={true} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <table style={tableStyle}>
              <tbody>
                <tr>
                  <th style={thStyle1}>Items</th>
                  <th style={thStyleStatus}>Status</th>
                  <th style={thStyleNote}>Description</th>
                  <th style={thStylequantity}>Quantity</th>
                  <th style={thStyleprice}>Price</th>
                  <th style={thStyleActions}>
                    <Fab
                      style={{
                        padding: '5px',
                        backgroundColor: '#5C76B7',
                        height: '30px',
                        width: '30px',
                        minHeight: '30px',
                      }}
                      size="small"
                      color="info"
                      aria-label="add"
                      onClick={() => handleAddFields()}
                    >
                      <AddIcon />
                    </Fab>
                  </th>
                </tr>
                {chargeItemInputFields.map((item, index) => {
                  return (
                    <tr key={item.status}>
                      <td style={tdStyle}>{index + 1}</td>
                      <td style={tdStyle}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Charge item status</InputLabel>
                          <Select
                            size="small"
                            name="status"
                            value={item.status}
                            label={'Charge item status'}
                          >
                            {chargeItemStatusInfo.map(v => (
                              <MenuItem
                                value={v.display}
                                onClick={event =>
                                  handleChangeInput(index, event)
                                }
                              >
                                {v.display}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td style={tdStyle}>
                        <TextField
                          size="small"
                          fullWidth
                          label="note"
                          name="note"
                          value={item.note}
                          onChange={event => handleChangeInput(index, event)}
                        />
                      </td>
                      <td style={tdStyle}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Quantity"
                          name="quantity"
                          value={item.quantity}
                          onChange={event => handleChangeInput(index, event)}
                        />
                      </td>
                      <td style={tdStyle}>
                        <TextField
                          size="small"
                          fullWidth
                          label="Price"
                          name="priceOverride"
                          value={item.priceOverride}
                          onChange={event => handleChangeInput(index, event)}
                        />
                      </td>
                      <td style={tdStyle}>
                        <Fab
                          style={{
                            padding: '5px',
                            backgroundColor: 'red',
                            height: '30px',
                            width: '30px',
                            minHeight: '30px',
                          }}
                          size="small"
                          color="info"
                          aria-label="add"
                          onClick={() => handleRemoveFields(index)}
                        >
                          <RemoveIcon />
                        </Fab>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={1}>
            <Typography>Sub total: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>${invoiceInitialState.totalPriceComponent}</Typography>
          </Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={1}>
            <Typography>Tax: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>0.00%</Typography>
          </Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={1}>
            <Typography>Total: </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography>${invoiceInitialState.totalPriceComponent}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Button
              variant="contained"
              fullWidth
              onClick={createInvoice}
              style={{ marginLeft: '50%' }}
            >
              Create Invoice
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default InvoicePage;
